<template>
  <header>
    <div :class="['menu-bar']">
      <a-row justify="space-between">
        <a-col :span="4">
          <div class="logo">
            <router-link to="/"><img src="/img/logo.png" alt="" /></router-link>
          </div>
        </a-col>
        <a-col :span="12" class="notify">
          <a-carousel :dots="false" :autoplay="true" effect="fade">
            <a @click="showNotify(t)" v-for="(t, i) in notifys" :key="i"
              ><a-icon type="notification" theme="filled" />{{
                t.titile | ellipsis(20)
              }}</a
            >
          </a-carousel>
          <a-modal v-model="showNotifyModal" :title="notify.titile" ok-text="确认" cancel-text="取消" @ok="showNotifyModal=false">
            <div v-html="notify.msgContent">
            </div>
          </a-modal>
        </a-col>
        <a-col :span="8">
          <div class="login-btn-wrap">
            <router-link
              class="btn-white"
              :to="{ path: '/user/login', query: { role: 'teacher' } }"
              >教师端</router-link
            >
            <router-link
              class="btn"
              :to="{ path: '/user/login', query: { role: 'student' } }"
              >学生端</router-link
            >
          </div>
        </a-col>
      </a-row>
    </div>
  </header>
</template>

<script>
import { getAnnountCement } from "@/api/sys";
export default {
  name: "MenuHome",
  data() {
    return {
      notifys: [],
      notify:{},
      showNotifyModal: false
    };
  },
  created() {
    getAnnountCement().then((res) => {
      this.notifys = res.result.records;
    });
  },
  methods: {
    showNotify(notify) {
      if (notify.href) {
        window.open(notify.href);
      } else {
        this.showNotifyModal = true
        this.notify = notify
      }
    },
  },
};
</script>

<style lang="less" scoped>
.menu-bar {
  padding: 10px;
  background: #fff;
  height: 70px;
  .logo {
    height: 40px;
    img {
      height: 100%;
    }
  }
  .notify {
    > div {
      display: inline-block;
      text-align: left;
      margin: 10px 5px;
      vertical-align: top;
    }
    .anticon {
      color: #000;
      margin-right: 10px;
    }

    .ant-carousel {
      width: 90%;
      a {
        color: #000;
      }
    }
  }
}
.login-btn-wrap {
  a {
    display: inline-block;
    cursor: pointer;
    width: 136px;
    height: 48px;
    margin-right: 16px;
    border: 1px solid @primary-color;
    border-radius: 30px;
    line-height: 48px;
    font-size: 14px;
    text-align: center;
  }
}
</style>